import {ITestAB} from "services-comun-meteored/modules/services/cmp/web/resources";
import {TestABSpec} from "./test-a-b-spec";

export class TestAB {
    /* STATIC */
    public static build(data: ITestAB): TestAB {
        return new TestAB(data);
    }

    /* INSTANCE */
    private readonly _spec: TestABSpec;
    private constructor(private readonly _data: ITestAB) {
        this._spec = TestABSpec.build(this.data.s);
    }

    private get data(): ITestAB {
        return this._data;
    }

    public get name(): string {
        return this.data.n;
    }

    public get spec(): TestABSpec {
        return this._spec;
    }
}
